import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n.jsx";
import { PageHeader, Empty } from "../components/Bits";
import PeriodFilter, { todayRange, periodOk } from "../components/PeriodFilter";

export default function Worktime() {
  const { t } = useI18n();
  const [rows, setRows] = useState([]);
  const [emps, setEmps] = useState({});
  const [period, setPeriod] = useState(todayRange());
  useEffect(() => {
    api.get("/employees").then((r) => { const m = {}; r.data.forEach((e) => m[e.id] = e.name); setEmps(m); }).catch(() => {});
  }, []);
  useEffect(() => {
    if (!periodOk(period)) return;
    api.get("/worktime", { params: { date_from: period.from, date_to: period.to } }).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [period]);
  return (
    <div data-testid="worktime-page">
      <PageHeader title={t("worktime")} subtitle={`${rows.length}`} />
      <PeriodFilter period={period} setPeriod={setPeriod} testid="wt-period" />
      {rows.length === 0 ? <Empty /> : (
        <div className="tactical-card overflow-x-auto">
          <table className="w-full text-sm min-w-[520px]">
            <thead><tr className="border-b text-left text-[var(--text-3)]">
              <th className="p-3">{t("name")}</th><th className="p-3">{t("date")}</th>
              <th className="p-3">{t("start")}</th><th className="p-3">{t("end")}</th><th className="p-3">{t("actual_hours")}</th>
            </tr></thead>
            <tbody>
              {rows.map((w) => (
                <tr key={w.id} className="border-b hover:bg-[var(--bg)]" data-testid={`wt-row-${w.id}`}>
                  <td className="p-3 font-semibold">{emps[w.user_id] || w.user_id.slice(0, 6)}</td>
                  <td className="p-3">{w.date}</td>
                  <td className="p-3 font-mono-num">{w.start_time ? new Date(w.start_time).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "—"}</td>
                  <td className="p-3 font-mono-num">{w.end_time ? new Date(w.end_time).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "▶"}</td>
                  <td className="p-3 font-mono-num font-semibold">{w.hours}h</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
